import React, { FC } from 'react';
import { Start, Stop, Svg } from './styles';

const Moon: FC<SVGIconProps> = ({ linearGradient, size = 48 }) => (
  <Svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <path
      d="M5.3335 32C5.33324 36.1871 6.31896 40.3154 8.21085 44.0507C10.1027 47.786 12.8476 51.0233 16.2233 53.5005C19.599 55.9777 23.5105 57.6252 27.6413 58.3096C31.7721 58.994 36.0059 58.6961 40.0002 57.44C34.5857 55.7384 29.8554 52.3538 26.4973 47.7784C23.1391 43.203 21.3283 37.6755 21.3283 32C21.3283 26.3245 23.1391 20.797 26.4973 16.2216C29.8554 11.6462 34.5857 8.26154 40.0002 6.55999C36.0059 5.30386 31.7721 5.00594 27.6413 5.69036C23.5105 6.37477 19.599 8.02228 16.2233 10.4995C12.8476 12.9767 10.1027 16.214 8.21085 19.9493C6.31896 23.6846 5.33324 27.8129 5.3335 32Z"
      fill="url(#paint0_linear_206_111)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_206_111"
        x1="22.6669"
        y1="-21.1851"
        x2="41.668"
        y2="60.4127"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Moon;
